export default "__VITE_ASSET__f1395234__"